import React from "react";
import { COUNTRIES, isKnownCountry } from "./countries";

type Props = {
  /** ISO-3166-1 alpha-2 code, or "" for unset. */
  value: string;
  onChange: (code: string) => void;
  id?: string;
};

/** Country select keyed by alpha-2 code. If `value` is a code we don't list (a
 *  rare suggested region), it's appended so the selection is never lost.
 *
 *  Deliberately a NATIVE <select> rather than the `Select` primitive: ~250
 *  options is exactly the case where the OS picker beats a custom listbox,
 *  especially on mobile. It wears `.vb-input` so it still matches the field set
 *  (AITS-486) — the shared control surface, minus the Radix behaviour. */
export function CountrySelect({ value, onChange, id }: Props) {
  const unknown = value && !isKnownCountry(value);
  return (
    <select
      id={id}
      className="vb-input vb-input--lg"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Market region (country)"
    >
      <option value="" disabled>
        Select a country…
      </option>
      {unknown && <option value={value}>{value}</option>}
      {COUNTRIES.map((c) => (
        <option key={c.code} value={c.code}>
          {c.name}
        </option>
      ))}
    </select>
  );
}

export default CountrySelect;
